<template>
  <div class="table_holder">
    <table>
      <thead>
        <tr> <th>名稱</th> <th>編輯</th> <th>查看</th> <th>紙本檔</th> </tr>
      </thead>
      <tbody>
        <tr>
          <td>校外實習學習計畫表</td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-plan-form', 'edit')">編輯</router-link> </td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-plan-form', 'view')">查看</router-link> </td>
          <td> <router-link class="d-inline-block btn--pill pill aqua" :to="detailPath('intern-plan-form', 'file')">上傳/下載</router-link> </td>
        </tr>
        <tr>
          <td>校外實習學生訪視輔導記錄表</td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('visit-counseling-form', 'edit')">編輯</router-link> </td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('visit-counseling-form', 'view')">查看</router-link> </td>
          <td> <router-link class="d-inline-block btn--pill pill aqua" :to="detailPath('visit-counseling-form', 'file')">上傳/下載</router-link> </td>
        </tr>
        <tr>
          <td>校外實習成績考評表</td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-score-form', 'edit')">編輯</router-link> </td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-score-form', 'view')">查看</router-link> </td>
          <td></td>
        </tr>
        <tr>
          <td>實習機構滿意度調查</td>
          <td></td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-satisfaction')">查看</router-link> </td>
          <td></td>
        </tr>
        <tr>
          <td>學生滿意度調查</td>
          <td></td>
          <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('student-satisfaction')">查看</router-link> </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'TeachersStudentDetailFormList',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  async created () {
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    detailPath(form_type, edit_type) {
      let path = `/teachers/intern-record/${this.$route.params.year}/${this.$route.params.eid}/${this.$route.params.sid}/${form_type}`;
      if(edit_type) return path + `/${edit_type}`;
      return path;
    },
  }
}
</script>
